import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'grid',
    gridTemplateColumns: '32px 50px 1fr 90px 90px 80px',
    alignItems: 'center',
    padding: theme.spacing(0.75, 1),
    borderRadius: 4,
    border: `1px solid ${theme.palette.grey[200]}`,
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  rowDragging: {
    boxShadow: theme.shadows[4],
    opacity: 0.95,
  },
  dragHandle: {
    cursor: 'grab',
    color: theme.palette.grey[400],
    display: 'flex',
    alignItems: 'center',
    '&:active': {
      cursor: 'grabbing',
    },
  },
  dragHandleDisabled: {
    opacity: 0.3,
    cursor: 'not-allowed',
    '&:active': {
      cursor: 'not-allowed',
    },
  },
  idCell: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  colorDot: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: `2px solid ${theme.palette.grey[300]}`,
    justifySelf: 'center',
  },
  nameCell: {
    fontSize: 13,
    color: theme.palette.text.primary,
    paddingRight: theme.spacing(1),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  nameCellWrapper: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
  },
  nameInput: {
    width: '100%',
    fontSize: 13,
    padding: '4px 6px',
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 4,
    outline: 'none',
    fontFamily: 'inherit',
    '&:focus': {
      borderColor: theme.palette.primary.main,
    },
  },
  defaultBadge: {
    fontSize: 10,
    color: theme.palette.text.secondary,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 3,
    padding: '1px 4px',
    marginLeft: 4,
    whiteSpace: 'nowrap',
  },
  infoIconWrapperSpaced: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 4,
    color: 'inherit',
  },
  actionsCell: {
    display: 'flex',
    gap: 2,
    justifyContent: 'flex-end',
  },
  actionBtn: {
    padding: 4,
  },
}))

export default useStyles
